import { render, staticRenderFns } from "./FrontPostTrebleCrochetIcon.vue?vue&type=template&id=1fe4a808&scoped=true"
import script from "./FrontPostTrebleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./FrontPostTrebleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./FrontPostTrebleCrochetIcon.vue?vue&type=style&index=0&id=1fe4a808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe4a808",
  null
  
)

export default component.exports